module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mt-cell-group', _vm._l((_vm.options), function(option) {
    return _c('mt-cell', {
      key: option.id,
      attrs: {
        "is-link": !!option.isParent
      },
      nativeOn: {
        "click": function($event) {
          _vm.handleClick(option)
        }
      }
    }, [_c('div', {
      staticClass: "mint-checklist-label",
      staticStyle: {
        "position": "relative"
      },
      attrs: {
        "slot": "title"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.handleClickGroup(option)
        }
      },
      slot: "title"
    }, [_c('label', {
      staticStyle: {
        "display": "flex"
      }
    }, [(!option.isParent || _vm.parentSelectable) ? _c('span', {
      staticClass: "mint-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.currentValue),
        expression: "currentValue"
      }],
      staticClass: "mint-checkbox-input",
      attrs: {
        "type": "checkbox",
        "disabled": option.disabled
      },
      domProps: {
        "value": option.id !== undefined ? option.id : option,
        "checked": Array.isArray(_vm.currentValue) ? _vm._i(_vm.currentValue, option.id !== undefined ? option.id : option) > -1 : (_vm.currentValue)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.currentValue,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = option.id !== undefined ? option.id : option,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.currentValue = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.currentValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.currentValue = $$c
          }
        }
      }
    }), _c('span', {
      staticClass: "mint-checkbox-core",
      class: ['mint-checkbox-core-' + _vm.iconpattern, {
        'mt-bg-after-white': _vm.iconpattern === 'circle'
      }, option.disabled ? 'mt-bg-grey-lv6 mt-bColor-grey-lv6 mt-bColor-after-white' : (_vm.currentValue.indexOf(option.id) > -1 ? 'mt-bg-primary mt-bColor-primary mt-bColor-after-white' : 'mt-bColor-grey-lv3 mt-bg-lv3')]
    })]) : _vm._e(), _c('span', {
      staticClass: "mint-checkbox-label",
      domProps: {
        "textContent": _vm._s(option.name || option)
      }
    })])])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18053b58","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/tree-selector/src/tree-checkbox-list.vue
// module id = 368
// module chunks = 0